import React from "react";
import { Mic2 } from "lucide-react";

/**
 * Cover the YouTube iframe with the DJ Gabo Karaoke logo as soon as a song ends,
 * to hide YouTube's "suggested videos" grid.
 *
 * mode = "inline" (player panel) | "fullscreen" (2nd screen)
 */
const EndOfVideoOverlay = ({ mode = "inline" }) => {
  const positioning = mode === "fullscreen" ? "fixed inset-0 z-40" : "absolute inset-0 z-25";
  const logoSize = mode === "fullscreen" ? "text-6xl sm:text-8xl md:text-9xl" : "text-3xl sm:text-5xl lg:text-6xl";
  const iconSize = mode === "fullscreen" ? "w-16 h-16" : "w-8 h-8";

  return (
    <div
      className={`${positioning} flex flex-col items-center justify-center bg-black/92 backdrop-blur-md animate-presentation-in overflow-hidden`}
      data-testid="end-of-video-overlay"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(255,42,109,0.18), transparent 55%)",
        }}
      />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 text-center px-6">
        <div className="inline-flex items-center justify-center gap-3 mb-3">
          <div className={`${iconSize} rounded-full bg-primary/15 border border-primary/40 flex items-center justify-center animate-glow-pulse`}>
            <Mic2 className={mode === "fullscreen" ? "w-8 h-8 text-primary" : "w-4 h-4 text-primary"} strokeWidth={2.2} />
          </div>
        </div>
        <h1 className={`font-display font-black uppercase tracking-tighter leading-[0.95] ${logoSize}`}>
          <span className="text-primary neon-pink animate-glow-pulse">DJ Gabo</span> <span className="text-white">Karaoke</span>
        </h1>
      </div>
    </div>
  );
};

export default EndOfVideoOverlay;
